{
    "nmb": [
        [
            0.1,
            "#DF5353"
        ],
        [
            0.3,
            "#DDDF0D"
        ],
        [
            0.45,
            "#55BF3B"
        ],
        [
            0.55,
            "#55BF3B"
        ],
        [
            0.7,
            "#DDDF0D"
        ],
        [
            0.9,
            "#DF5353"
        ]
    ],
    "R": [
        [
            0.1,
            "#DF5353"
        ],
        [
            0.5,
            "#DDDF0D"
        ],
        [
            0.8,
            "#55BF3B"
        ]
    ],
    "fge": [
        [
            0.3,
            "#55BF3B"
        ],
        [
            0.5,
            "#DDDF0D"
        ],
        [
            0.8,
            "#DF5353"
        ]
    ],
    "nrms": [
        [
            0.1,
            "#55BF3B"
        ],
        [
            0.5,
            "#DDDF0D"
        ],
        [
            0.9,
            "#DF5353"
        ]
    ]
}